import { useEffect, useRef, useState } from 'react';

import { REVEAL_DURATION_MS } from '@/design-system';

export const useDeferredRemove = (remove: (_index: number) => void) => {
  const [exitingIndex, setExitingIndex] = useState<number | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => () => clearTimeout(timer.current), []);

  const requestRemove = (index: number) => {
    setExitingIndex(index);

    timer.current = setTimeout(() => {
      remove(index);
      setExitingIndex(null);
    }, REVEAL_DURATION_MS);
  };

  return { exitingIndex, requestRemove };
};
